import { ItemJobStatus } from "./enums";

export const canAddItemJobInLocation = (itemJobStatus?: string) => {
  if (!itemJobStatus) return true;

  return ![ItemJobStatus.DELIVERED, ItemJobStatus.MISSING, ItemJobStatus.VOID]
    .map((status) => status.toString())
    .includes(itemJobStatus);
};
